module.exports = __webpack_public_path__ + "static/media/aeropay_connect_bank.19cb335c.png";